<template>
  <a href="#" class="list-group-item pl-5" @click="switchGroup()">
    <i class="fas fa-users fa-fw"></i>{{ name }}
  </a>
  
</template>
<script>
import axios from "axios";
//let $ = JQuery
export default {
  name: 'GroupOnlyButton',
  props: {
    name: String,
    group: null,
    is_group: false,
    accounts: []
  },
  data() {
    return {
      show_list: true,
      balance: 0
    }
  },
  methods: {
    switchGroup() {
      this.$store.commit('switch_group', this.group)
      this.$store.dispatch('loadData')
    },
  },
  computed: {

  },
  mounted() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-group-item {
  padding: 6px 10px
}

.pl-5 {
  padding-left: 2.2rem !important;
}
</style>
